export const ARCHIVE_STUDENT_CARD = 'ARCHIVE_STUDENT_CARD';
export const UPDATE_STUDENT_CARD_RATE = 'UPDATE_STUDENT_CARD_RATE';
